import axios from 'axios';
import { authErrorMessage } from '@/features/auth/error-message';
import { SERVER_ERROR_MESSAGE_KEYS } from './labels';

/**
 * IAM organizasyon hatasi -> KULLANICIYA GOSTERILEBILIR metin.
 *
 * Bu uclar (girisin aksine) Turkce mesaj DEGIL sabit bir KOD doner:
 * 'LAST_ADMIN_PROTECTED', 'CANNOT_MODIFY_OWN_MEMBERSHIP'... Kodu oldugu gibi
 * basmak kullaniciya hicbir sey anlatmaz; once tabloya bakilir.
 *
 * Tablo tutmayan her sey `authErrorMessage`e devredilir — ag hatasi, 429 ve
 * "sunucu zaten Turkce yaziyor" durumlari orada tek yerde cozulmus durumda;
 * ikinci bir kopya ikisinin ayrismasi demek olurdu.
 */
export const iamErrorMessage = (error: unknown, t: (key: string) => string): string => {
  const raw = rawServerCode(error);
  const key = raw === null ? undefined : SERVER_ERROR_MESSAGE_KEYS[raw];
  if (key !== undefined) return t(key);
  return authErrorMessage(error, t);
};

const rawServerCode = (error: unknown): string | null => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as { message?: unknown } | undefined;
    return typeof data?.message === 'string' ? data.message : null;
  }
  // Zarf hatasi (HTTP 200 + code:'error'): api.ts kodu Error mesajina koyuyor.
  if (error instanceof Error) return error.message;
  return null;
};
